'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var Slider = require('react-slick');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var SliderArrow = require('./SliderArrow.js');
require('./Slick.module.css.js');
var Carousel_module = require('./Carousel.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Slider__default = /*#__PURE__*/_interopDefaultLegacy(Slider);

const Carousel = ({
  slickProps,
  itemsCount,
  children,
  onArrowClick = () => {},
  carouselContainerStyles = {},
  carouselControlsContainerStyles = {}
}) => {
  const customSlider = React.useRef(null);
  const {
    dots,
    infinite,
    responsive
  } = slickProps || {};
  const windowWidth = nthKitDynamicLayoutNext.useWindowSize({}).width || 0;

  // Sometimes the API does not send any responsive object, that's why it is necessary to validate that it exists.
  if (responsive)
    // Sort the elements from smallest to largest in breakpoints to later validate which object should be sent to you.
    responsive.sort((a, b) => {
      return a.breakpoint - b.breakpoint;
    });
  const responsiveObj = responsive ? responsive.find(responsiveObject => {
    return windowWidth < responsiveObject.breakpoint;
  }) : undefined;
  const showDots = responsiveObj && typeof responsiveObj.settings === 'object' && typeof responsiveObj.settings.dots !== 'undefined' ? responsiveObj.settings.dots : dots;
  const className = itemsCount && itemsCount <= 1 ? Carousel_module["default"].containerLessItems : Carousel_module["default"].container;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    role: "contentinfo",
    className: className,
    style: carouselContainerStyles
  }, /*#__PURE__*/React__default["default"].createElement(Slider__default["default"], _extends__default["default"]({
    ref: customSlider,
    appendDots: sliderDots => {
      const numDots = React.Children.count(sliderDots);
      let activeDotIndex;
      React.Children.forEach(sliderDots, (dot, i) => {
        if (/*#__PURE__*/React.isValidElement(dot) && dot.props.className === 'slick-active') {
          activeDotIndex = i;
        }
      });
      return /*#__PURE__*/React__default["default"].createElement("div", {
        style: carouselControlsContainerStyles
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: Carousel_module["default"].controls
      }, /*#__PURE__*/React__default["default"].createElement(SliderArrow["default"], {
        onClick: e => {
          if (customSlider.current) customSlider.current.slickPrev();
          if (onArrowClick) onArrowClick(e);
        }
        // The default value for `infinite` is true. This means receiving
        // `slickProps.infinite: undefined` actually means
        // `infinite: true`. So, explicitly check for false.
        ,
        disabled: infinite === false && activeDotIndex === 0,
        arrowPosition: SliderArrow.ArrowPosition.ARROW_PREV
      }), showDots ? /*#__PURE__*/React__default["default"].createElement("ul", {
        className: Carousel_module["default"].unorderedList
      }, sliderDots) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null), /*#__PURE__*/React__default["default"].createElement(SliderArrow["default"], {
        onClick: e => {
          if (customSlider.current) customSlider.current.slickNext();
          if (onArrowClick) onArrowClick(e);
        }
        // The default value for `infinite` is true. This means receiving
        // `slickProps.infinite: undefined` actually means
        // `infinite: true`. So, explicitly check for false.
        ,
        disabled: infinite === false && activeDotIndex === numDots - 1,
        arrowPosition: SliderArrow.ArrowPosition.ARROW_NEXT
      })));
    },
    arrows: false,
    speed: 300
  }, slickProps, {
    // Dont remove the dots, this need to be always true because we put the arrows in the dots prop
    dots: true,
    responsive: responsive && responsive.map(breakpoint => ({
      ...breakpoint,
      settings: typeof breakpoint.settings === 'object' ? {
        ...breakpoint.settings,
        dots: true
      } : breakpoint.settings
    }))
  }), children));
};

exports.ArrowPosition = SliderArrow.ArrowPosition;
exports.SliderArrow = SliderArrow["default"];
exports["default"] = Carousel;
